import { lazy } from 'react'
import type { RouteProps } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

const Startup = lazy(() => import('@/app/(pages)/startup/page'))
const BlogDetail = lazy(() => import('@/app/(pages)/startup/components/BlogDetail'))
const Login = lazy(() => import('../components/auth/Login'))
const Dashboard = lazy(() => import('../components/admin/Dashboard'))

export type RoutesProps = {
  path: RouteProps['path']
  name: string
  element?: RouteProps['element']
  exact?: boolean
  children?: {
    path: string
    element: React.ReactElement
  }[]
}

const demoPages: RoutesProps[] = [
  {
    path: '/',
    name: 'root',
    element: <Startup />,
  },
  {
    path: '/blog/:slug',
    name: 'BlogDetail',
    element: <BlogDetail />,
  }
]

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('token')
  return token ? <>{children}</> : <Navigate to="/admin/login" />
}

export const appRoutes = [
  {
    path: '/admin',
    name: 'admin',
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'dashboard',
        element: <PrivateRoute><Dashboard /></PrivateRoute>
      }
    ]
  },
  ...demoPages
]
